<app-loading *ngIf="contentReady"></app-loading>

<div class="product-page" *ngIf="product">

  <!-- HERO CARD -->
  <section class="product-hero-card">

    <!-- IMAGE -->
    <div class="product-media">

      <div *ngIf="calcDis(product.pricea, product.price) != 0" class="discountbadge">
        {{ calcDis(product.pricea, product.price) }}% {{ "discount" | transloco }}
      </div>

      <div class="swiper bundle-swiper" #bundleSwiper *ngIf="bundleSlides.length">
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let img of bundleSlides">
            <img class="bundle-main-img" [lazyLoad]="img" [defaultImage]="'/assets/imageloading.gif'"
              [errorImage]="'/assets/noproduct.png'" alt="bundle" />
          </div>
        </div>

        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    <!-- INFO -->
    <div class="product-summary">

      <h1 class="product-title">
        {{ isAr ? product.name_ar : product.name_en }}
      </h1>

      <!-- PET TYPE -->
      <div class="pet-badge" [ngSwitch]="product?.items[0].pet">
        <span *ngSwitchCase="'0'">
          <img src="/assets/e-commerce/icons/8.webp" alt="cats">
          {{ "cats" | transloco }}
        </span>
        <span *ngSwitchCase="'1'">
          <img src="/assets/e-commerce/icons/11.webp" alt="dogs">
          {{ "dogs" | transloco }}
        </span>
        <span *ngSwitchCase="'2'">
          <img src="/assets/e-commerce/icons/13.webp" alt="birds">
          {{ "birds" | transloco }}
        </span>
        <span *ngSwitchCase="'4'">
          <img src="/assets/e-commerce/icons/10.webp" alt="cats&dogs">
          {{ "cats&dogs" | transloco }}
        </span>
        <span *ngSwitchCase="'3'">
          <img src="/assets/e-commerce/icons/25.png" alt="other">
          {{ "other" | transloco }}
        </span>
      </div>

      <!-- PRICE -->
      <div class="price-box">
        <div class="price-row">
          <span class="new-price">{{ product.pricea }} {{ "egpe" | transloco }}</span>
          <span class="old-price" *ngIf="calcDis(product.pricea,product.price) != 0">
            {{ product.price }} {{ "egpe" | transloco }}
          </span>
        </div>

        <div class="save-badge" *ngIf="calcDis(product.pricea,product.price) != 0">
          وفر {{ product.price - product.pricea }} {{ "egpe" | transloco }}
        </div>
      </div>

      <!-- QUICK SELLING POINTS -->
      <div class="quick-highlights">
        <span>✅ {{ "cashpayment" | transloco }}</span>
        <span>✅ {{ "returns" | transloco }}</span>
        <span>✅ {{ "cashback" | transloco }}</span>
      </div>

      <!-- SHORT DESCRIPTION -->
      <div class="short-desc">
        @if(isAr){
        {{ product.description_ar }}
        }
        @else{
        {{ product.description_en }}
        }
      </div>

      <!-- QUANTITY + CTA -->
      <div class="buy-box">
        <div class="quantity-controls cartpage">
          <button (click)="min(product)" class="qty-btn">-</button>
          <span class="qty-value">{{ quantity }}</span>
          <button (click)="plus(product)" class="qty-btn">+</button>
        </div>

        <button class="btn-add-main" (click)="plus(product)">
          {{ "addtocart" | transloco }}
        </button>
      </div>

    </div>
  </section>

  <!-- BUNDLE ITEMS -->
  <section class="section-card" *ngIf="product?.items?.length">
    <div class="section-title">
      {{ "Show Bundle Items" | transloco }}
    </div>

    <div class="bundle-items-premium">
      <div class="bundle-chip" *ngFor="let item of product.items">
        <div class="chip-img">
          <img [lazyLoad]="fixImage(item.stock.image)" alt="item">
        </div>

        <div class="chip-content">
          <span class="chip-qty">×{{ item.quantity }}</span>
          <span class="chip-name">
            {{ isAr ? item.stock.name_ar : item.stock.name_en }}
          </span>
        </div>
      </div>
    </div>
  </section>

  <!-- FULL DESCRIPTION -->
  <section class="section-card">
    <div class="section-title">
      {{ "Show Description" | transloco }}
    </div>

    <p class="product-description">
      @if(isAr){
      {{ product.name_ar }}
      <br><br>
      {{ product.description_ar }}
      }
      @else{
      {{ product.name_en }}
      <br><br>
      {{ product.description_en }}
      }
    </p>
  </section>

  <!-- TRUST -->
  <section class="section-card">
    <div class="section-title text-primary">
      {{ "trustshopping" | transloco }}
    </div>

    <div class="trust-grid">
      <div class="trust-item">
        <img src="/assets/e-commerce/icons/40.webp" alt="">
        <span>{{ "cashpayment" | transloco }}</span>
      </div>

      <div class="trust-item">
        <img src="/assets/e-commerce/icons/41.webp" alt="">
        <span>{{ "returns" | transloco }}</span>
      </div>

      <div class="trust-item">
        <img src="/assets/e-commerce/icons/42.webp" alt="">
        <span>{{ "cashback" | transloco }}</span>
      </div>

      <div class="trust-item">
        <img src="/assets/e-commerce/icons/43.webp" alt="">
        <span>{{ "trusttrans" | transloco }}</span>
      </div>
    </div>
  </section>

  <app-productrecommendation style="padding: 0 !important;"></app-productrecommendation>
</div>